import React from 'react';
import { useBasename } from 'react-admin';

/**
 * Paths to the Launch Manager pages. The basename has to be explicit: the
 * router itself has none, so a bare path would land outside the admin.
 */
export const useLaunchPaths = () => {
  const basename = useBasename();
  return React.useMemo(
    () => ({
      list: `${basename}/launchManager`,
      newClient: `${basename}/launchManager/new`,
      launch: (id: string) => `${basename}/launchManager/${id}`,
    }),
    [basename],
  );
};
